import { render, staticRenderFns } from "./occasions.vue?vue&type=template&id=49ce66de&"
import script from "./occasions.vue?vue&type=script&lang=js&"
export * from "./occasions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports